import { toast } from "react-toastify";

export function showValidateErrors(errors) {
  Object.keys(errors).forEach((k) => {
    const error = errors[k];
    if (Array.isArray(error)) {
      toast.error(parse(error[0]));
    }
  });
}
/**
 *
 * @param {string} value
 */
function parse(value) {
  return value.split("|")[0];
}
